import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-remove-zc-job-process-details-view',
    templateUrl: './remove-zc-job-process-details-view.component.html',
    styleUrls: ['./remove-zc-job-process-details-view.component.scss']
})
export class RemoveZcJobProcessDetailsViewComponent implements OnInit {
    @Input()
    process: ITaskModel;

    @Input()
    hideHeaders: boolean;

    constructor() {}

    ngOnInit(): void {}
}
